// 商城首页装修
import {
  WgtPage,
  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,

  WgtStickyLift,
  WgtTabsCut,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,

  WgtAroundStoreOne,
  WgtAbtest,
  WgtProductShelves,
  WgtContentPart,
  WgtLift,
  WgtCustomWgt,
  WgtImageText,
  WgtArticle,
  WgtClassify,
  WgtMemberInfo,
  WgtSuspension,
  WgtOfficialAccount,
  WgtUserContainer,
  WgtNewMemberInfo,
  wgtDevices,
  WgtMemberTask,
  wgtCrmMemberActivity,
}from '../wgts'

export const initiWidgets = []

export const widgets =  {
  WgtPage,
  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,

  WgtStickyLift,
  WgtTabsCut,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,

  WgtAroundStoreOne,
  WgtAbtest,
  WgtCustomWgt,
  WgtProductShelves,
  WgtContentPart,
  WgtLift,
  WgtImageText,
  WgtArticle,
  WgtMemberInfo,
  WgtClassify,
  WgtSuspension,
  WgtOfficialAccount,
  WgtUserContainer,
  WgtNewMemberInfo,
  wgtDevices,
  WgtMemberTask,
  wgtCrmMemberActivity,
}



export default {
  widgets,
  initiWidgets
}
